import ButtonCircle from "../../../../shared/components/button_circle"
import ButtonBig from "../../../../shared/components/button_big"
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectGtoState } from "../../../../stateManagement/redux"
import ButtonSmall from "../../../../shared/components/button_small";
import { Tooltip } from '@mui/material';
import { MultiPositionSwitch } from "../../../../shared/components/MultiPositionSwitch";

export const ActivitiesList = ({ sortsActivities, errors }: { sortsActivities: any[], errors: any }) => {

    const [activeActivity, setActiveActivity] = useState<any>(undefined)

    if (activeActivity) {
        return (
            <div className="consolidate_files_container_cuadrillas_container">
                <div className="consolidate_files_container_custom_input">
                    <ButtonSmall text={"Ver lista"} icon="/assets/icons/back.svg" onClick={()=>setActiveActivity(undefined)} />
                </div>
                <div className='consolidate_files_container_table_container'>
                    {Object.keys(activeActivity).map((a, i) => {

                        const omit = ['line', 'position', 'haveCart', 'dynCarts', 'fileName', 'taskId', 'originFlow']

                        if (omit.includes(a.trim())) return null

                        const errorsForFile = errors[activeActivity["fileName"]]

                        let isColumnInError = errorsForFile.find((e: any) => e.variable === a.trim())

                        if (isColumnInError) {
                            const doesMessageHaveError = isColumnInError.valueWithError === activeActivity[a]
                            // console.log({ doesMessageHaveError, isColumnInError, activeActivity: activeActivity[a], a })
                            if (!doesMessageHaveError || isColumnInError.type === 'warning') {
                                isColumnInError = undefined
                            }
                        }

                        return (
                            <Tooltip key={i} title={isColumnInError ? isColumnInError.error : ''} arrow>
                                <div key={i} className={`consolidate_files_container_activity_detail_container ${isColumnInError && 'consolidate_files_container_alert_row'}`}>
                                    <div>{a}</div>
                                    <div>{activeActivity[a]}</div>
                                </div>
                            </Tooltip>
                        )
                    })}</div>
            </div>
        )
    }


    return (
        <>
            <div className="consolidate_files_container_v2_cuadrillas_container">
                <div className='consolidate_files_container_v2_table_container'>
                    <div className='consolidate_files_container_v2_table_header'>
                        <div>Pozo</div>
                        <div>Ingenieros</div>
                        <div />
                    </div>
                    <div className="consolidate_files_container_v2_table_info_container">
                        {sortsActivities.map((c, i) => (
                            <div key={i} className={`consolidate_files_container_v2_table_row ${c.errorWithLocation && 'consolidate_files_container_v2_alert_row'}`}>
                                <div>{c.Pozo}</div>
                                <div>{c.Ingenieros}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}